export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 mb-12">
          <div className="col-span-2 md:col-span-1">
            <img
              src="https://static.readdy.ai/image/629c9343645c6844591b8b96cb81f5f4/a8f8b5c882432f4c1a0b17d9e5ef2291.jpeg"
              alt="PACKTO"
              className="h-10 md:h-12 mb-4 brightness-0 invert"
            />
            <p className="text-gray-400 text-xs md:text-sm">
              Innovación que mueve tu industria
            </p>
          </div>

          <div>
            <h4 className="font-bold text-white text-sm md:text-base mb-4">Soluciones</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection('about')} className="text-gray-400 hover:text-orange-400 transition-colors text-xs md:text-sm cursor-pointer">
                  Renting
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('about')} className="text-gray-400 hover:text-orange-400 transition-colors text-xs md:text-sm cursor-pointer">
                  Desarrollo Custom
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('about')} className="text-gray-400 hover:text-orange-400 transition-colors text-xs md:text-sm cursor-pointer">
                  IA
                </button>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors text-xs md:text-sm cursor-pointer">
                  Mantenimiento
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-white text-sm md:text-base mb-4">Empresa</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection('about')} className="text-gray-400 hover:text-orange-400 transition-colors text-xs md:text-sm cursor-pointer">
                  Sobre Nosotros
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('projects')} className="text-gray-400 hover:text-orange-400 transition-colors text-xs md:text-sm cursor-pointer">
                  Proyectos
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('team')} className="text-gray-400 hover:text-orange-400 transition-colors text-xs md:text-sm cursor-pointer">
                  Equipo
                </button>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors text-xs md:text-sm cursor-pointer">
                  Blog
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-white text-sm md:text-base mb-4">Soporte</h4>
            <ul className="space-y-2">
              <li>
                <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors text-xs md:text-sm cursor-pointer">
                  FAQ
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors text-xs md:text-sm cursor-pointer">
                  Documentación
                </a>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-gray-400 hover:text-orange-400 transition-colors text-xs md:text-sm cursor-pointer">
                  Contacto
                </button>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors text-xs md:text-sm cursor-pointer">
                  Garantías
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-gray-400 text-xs md:text-sm text-center md:text-left" style={{ fontFamily: 'serif' }}>
              © PACKTO 2025 - Todos los derechos reservados
            </div>
            
            <div className="flex items-center gap-4 md:gap-6">
              <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-orange-400 transition-colors cursor-pointer">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-linkedin-box-fill text-lg md:text-xl"></i>
                </div>
              </a>
              <a href="https://www.youtube.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-orange-400 transition-colors cursor-pointer">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-youtube-fill text-lg md:text-xl"></i>
                </div>
              </a>
              <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-orange-400 transition-colors cursor-pointer">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-instagram-fill text-lg md:text-xl"></i>
                </div>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-orange-400 transition-colors cursor-pointer">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-twitter-x-fill text-lg md:text-xl"></i>
                </div>
              </a>
            </div>
          </div>

          <div className="mt-8 text-center">
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-gray-500 hover:text-orange-400 text-xs transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>

      <div className="bg-black py-10 md:py-12">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-3 gap-6 md:gap-8 items-center">
            <div className="rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/534ac441058d964ae3ac55bd0b570753.jpg"
                alt="Planta de producción"
                className="w-full h-40 md:h-48 object-cover"
              />
            </div>

            <div className="text-center">
              <h3 className="text-3xl md:text-4xl lg:text-5xl font-light text-white leading-tight" style={{ fontFamily: 'serif' }}>
                Tecnología
                <br />
                que Transforma
                <br />
                Industrias
              </h3>
            </div>

            <div className="bg-gray-900 p-5 md:p-6 rounded-2xl">
              <p className="text-gray-400 text-xs md:text-sm mb-4">
                Suscríbete a nuestro newsletter para novedades en automatización
              </p>
              <div className="flex gap-2">
                <input
                  type="email"
                  placeholder="tu@email.com"
                  className="flex-1 px-3 md:px-4 py-2 md:py-2.5 bg-gray-800 border-2 border-gray-700 rounded-full text-white text-xs md:text-sm focus:border-orange-500 focus:outline-none transition-colors"
                />
                <button className="px-4 md:px-6 py-2 md:py-2.5 bg-gradient-to-r from-orange-500 to-green-500 text-white text-xs md:text-sm font-semibold rounded-full hover:shadow-lg transition-all whitespace-nowrap cursor-pointer">
                  Suscribir →
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
